window.TJ_WXEmoji = {
    "/::)":{
        "meaning":"微笑",
        "original":"0.png"
    },
    "/::~":{
        "meaning":"撇嘴",
        "original":"1.png"
    },
    "/::B":{
        "meaning":"色",
        "original":"2.png"
    },
    "/::|":{
        "meaning":"发呆",
        "original":"3.png"
    },
    "/:8-)":{
        "meaning":"得意",
        "original":"4.png"
    },
    "/::<":{
        "meaning":"流泪",
        "original":"5.png"
    },
    "/::$":{
        "meaning":"害羞",
        "original":"6.png"
    },
    "/::X":{
        "meaning":"闭嘴",
        "original":"7.png"
    },
    "/::Z":{
        "meaning":"睡",
        "original":"8.png"
    },
    "/::'(":{
        "meaning":"大哭",
        "original":"9.png"
    },
    "/::-|":{
        "meaning":"尴尬",
        "original":"10.png"
    },
    "/::@":{
        "meaning":"发怒",
        "original":"11.png"
    },
    "/::P":{
        "meaning":"调皮",
        "original":"12.png"
    },
    "/::D":{
        "meaning":"呲牙",
        "original":"13.png"
    },
    "/::O":{
        "meaning":"惊讶",
        "original":"14.png"
    },
    "/::(":{
        "meaning":"难过",
        "original":"15.png"
    },
    "/::+":{
        "meaning":"酷",
        "original":"16.png"
    },
    "/:--b":{
        "meaning":"囧",
        "original":"17.png"
    },
    "/::Q":{
        "meaning":"抓狂",
        "original":"18.png"
    },
    "/::T":{
        "meaning":"吐",
        "original":"19.png"
    },
    "/:,@P":{
        "meaning":"偷笑",
        "original":"20.png"
    },
    "/:,@-D":{
        "meaning":"愉快",
        "original":"21.png"
    },
    "/::d":{
        "meaning":"白眼",
        "original":"22.png"
    },
    "/:,@o":{
        "meaning":"傲慢",
        "original":"23.png"
    },
    "/::g":{
        "meaning":"饥饿",
        "original":"24.png"
    },
    "/:|-)":{
        "meaning":"困",
        "original":"25.png"
    },
    "/::!":{
        "meaning":"惊恐",
        "original":"26.png"
    },
    "/::L":{
        "meaning":"流汗",
        "original":"27.png"
    },
    "/::>":{
        "meaning":"憨笑",
        "original":"28.png"
    },
    "/::,@":{
        "meaning":"悠闲",
        "original":"29.png"
    },
    "/:,@f":{
        "meaning":"奋斗",
        "original":"30.png"
    },
    "/::-S":{
        "meaning":"咒骂",
        "original":"31.png"
    },
    "/:?":{
        "meaning":"疑问",
        "original":"32.png"
    },
    "/:,@x":{
        "meaning":"嘘",
        "original":"33.png"
    },
    "/:,@@":{
        "meaning":"晕",
        "original":"34.png"
    },
    "/::8":{
        "meaning":"疯了",
        "original":"35.png"
    },
    "/:,@!":{
        "meaning":"哀",
        "original":"36.png"
    },
    "/:!!!":{
        "meaning":"骷髅",
        "original":"37.png"
    },
    "/:xx":{
        "meaning":"敲打",
        "original":"38.png"
    },
    "/:bye":{
        "meaning":"再见",
        "original":"39.png"
    },
    "/:wipe":{
        "meaning":"擦汗",
        "original":"40.png"
    },
    "/:dig":{
        "meaning":"抠鼻",
        "original":"41.png"
    },
    "/:handclap":{
        "meaning":"鼓掌",
        "original":"42.png"
    },
    "/:&-(":{
        "meaning":"糗大了",
        "original":"43.png"
    },
    "/:B-)":{
        "meaning":"坏笑",
        "original":"44.png"
    },
    "/:<@":{
        "meaning":"左哼哼",
        "original":"45.png"
    },
    "/:@>":{
        "meaning":"右哼哼",
        "original":"46.png"
    },
    "/::-O":{
        "meaning":"哈欠",
        "original":"47.png"
    },
    "/:>-|":{
        "meaning":"鄙视",
        "original":"48.png"
    },
    "/:P-(":{
        "meaning":"委屈",
        "original":"49.png"
    },
    "/::'|":{
        "meaning":"快哭了",
        "original":"50.png"
    },
    "/:X-)":{
        "meaning":"阴险",
        "original":"51.png"
    },
    "/::*":{
        "meaning":"亲亲",
        "original":"52.png"
    },
    "/:@x":{
        "meaning":"吓",
        "original":"53.png"
    },
    "/:8*":{
        "meaning":"可怜",
        "original":"54.png"
    },
    "/:pd":{
        "meaning":"菜刀",
        "original":"55.png"
    },
    "/:<W>":{
        "meaning":"西瓜",
        "original":"56.png"
    },
    "/:beer":{
        "meaning":"啤酒",
        "original":"57.png"
    },
    "/:basketb":{
        "meaning":"篮球",
        "original":"58.png"
    },
    "/:oo":{
        "meaning":"乒乓",
        "original":"59.png"
    },
    "/:coffee":{
        "meaning":"咖啡",
        "original":"60.png"
    },
    "/:eat":{
        "meaning":"饭",
        "original":"61.png"
    },
    "/:pig":{
        "meaning":"猪头",
        "original":"62.png"
    },
    "/:rose":{
        "meaning":"玫瑰",
        "original":"63.png"
    },
    "/:fade":{
        "meaning":"凋谢",
        "original":"64.png"
    },
    "/:showlove":{
        "meaning":"嘴唇",
        "original":"65.png"
    },
    "/:heart":{
        "meaning":"爱心",
        "original":"66.png"
    },
    "/:break":{
        "meaning":"心碎",
        "original":"67.png"
    },
    "/:cake":{
        "meaning":"蛋糕",
        "original":"68.png"
    },
    "/:li":{
        "meaning":"闪电",
        "original":"69.png"
    },
    "/:bome":{
        "meaning":"炸弹",
        "original":"70.png"
    },
    "/:kn":{
        "meaning":"刀",
        "original":"71.png"
    },
    "/:footb":{
        "meaning":"足球",
        "original":"72.png"
    },
    "/:ladybug":{
        "meaning":"瓢虫",
        "original":"73.png"
    },
    "/:shit":{
        "meaning":"便便",
        "original":"74.png"
    },
    "/:moon":{
        "meaning":"月亮",
        "original":"75.png"
    },
    "/:sun":{
        "meaning":"太阳",
        "original":"76.png"
    },
    "/:gift":{
        "meaning":"礼物",
        "original":"77.png"
    },
    "/:hug":{
        "meaning":"拥抱",
        "original":"78.png"
    },
    "/:strong":{
        "meaning":"强",
        "original":"79.png"
    },
    "/:weak":{
        "meaning":"弱",
        "original":"80.png"
    },
    "/:share":{
        "meaning":"握手",
        "original":"81.png"
    },
    "/:v":{
        "meaning":"胜利",
        "original":"82.png"
    },
    "/:@)":{
        "meaning":"抱拳",
        "original":"83.png"
    },
    "/:jj":{
        "meaning":"勾引",
        "original":"84.png"
    },
    "/:@@":{
        "meaning":"拳头",
        "original":"85.png"
    },
    "/:bad":{
        "meaning":"差劲",
        "original":"86.png"
    },
    "/:lvu":{
        "meaning":"爱你",
        "original":"87.png"
    },
    "/:no":{
        "meaning":"NO",
        "original":"88.png"
    },
    "/:ok":{
        "meaning":"OK",
        "original":"89.png"
    },
    "/:love":{
        "meaning":"爱情",
        "original":"90.png"
    },
    "/:<L>":{
        "meaning":"飞吻",
        "original":"91.png"
    },
    "/:jump":{
        "meaning":"跳跳",
        "original":"92.png"
    },
    "/:shake":{
        "meaning":"发抖",
        "original":"93.png"
    },
    "/:<O>":{
        "meaning":"怄火",
        "original":"94.png"
    },
    "/:circle":{
        "meaning":"转圈",
        "original":"95.png"
    },
    "/:kotow":{
        "meaning":"磕头",
        "original":"96.png"
    },
    "/:turn":{
        "meaning":"回头",
        "original":"97.png"
    },
    "/:skip":{
        "meaning":"跳绳",
        "original":"98.png"
    },
    "/:oY":{
        "meaning":"投降",
        "original":"99.png"
    },
    "/:#-0":{
        "meaning":"激动",
        "original":"100.png"
    },
    "/:hiphot":{
        "meaning":"乱舞",
        "original":"101.png"
    },
    "/:kiss":{
        "meaning":"献吻",
        "original":"102.png"
    },
    "/:<&":{
        "meaning":"左太极",
        "original":"103.png"
    },
    "/:&>":{
        "meaning":"右太极",
        "original":"104.png"
    }
}


// WEBPACK FOOTER //
// ./src/assets/scripts/TJ_WXEmoji.js